var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"b-tips"},[_vm._v(" 温馨提示：本测试仅为娱乐，切勿深信。 "),_c('span',[_c('a',{attrs:{"href":"./articleList/txt.html"}},[_vm._v("免责声明")])])])}]

export { render, staticRenderFns }